import React, { FC } from 'react'
import styled from 'styled-components'

export interface AutoShipControlLabelProps {
  className?: string
  disabled?: boolean
  showSaveText?: boolean | null
}

const SaveChip = styled.span`
  color: ${({ theme }) => theme.colors.grayscale.white};
  background: #e86050;
  margin-left: auto;
  padding: 6px;
  border-radius: 8px;
  font-size: 10px;
  font-weight: 600;
  line-height: normal;
  white-space: nowrap;
  &.auto-ship-label-cart {
    margin-left: 10px;
  }
`

export const AutoShipControlLabel: FC<AutoShipControlLabelProps> = ({
  className,
  disabled,
  showSaveText,
}) => {
  return showSaveText ? (
    <>Auto-Ship {disabled ? 'Save 5%' : <SaveChip className={className}>Save 5%</SaveChip>}</>
  ) : (
    <>Auto-Ship</>
  )
}
